import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { COMMAND_CENTER_MARK_LOADED } from '../actions/loadStatus.actions';

const initialState = {};

/**
 * Tracks which command-center slices have completed their fetch (success or
 * swallowed 403). State is a plain object: { [CommandCenterLoadKey]: true }.
 * A missing key means "not yet loaded"; the value is always `true` when present.
 */
const loadStatusReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case COMMAND_CENTER_MARK_LOADED:
        draft[payload.key] = true;

        return;

      case RESET_STATE:
        return initialState;

      default:
        return draft;
    }
  });

export default loadStatusReducer;
